import React from 'react';
import { useHistory } from 'hooks/router';
import Inputs from 'components/inputs/inputs';

import image_error from 'assets/images/error-item-missing.png';

export default function ErrorItemNotFound(props) {
  const history = useHistory();

  return (
    <div className='row justify-content-md-center mt-4'>
      <div className='col-12 col-md-10 col-xl-8'>
        <div className='text-center'>
          <img src={image_error} alt='Error' />
        </div>
        <div className='text-center'>
          <h1 className='text-danger font-weight-lighter mt-2'>Item could not be found</h1>
          <Inputs.Button variant='default' className='my-2' onClick={() => history.goBack()}>Back To Previous Page</Inputs.Button>
          <h5 className='text-normal mt-3'>We're sorry we could not locate the item you requested.</h5>
        </div>
      </div>
    </div>
  );
}